import * as api from '~services/api'; // eslint-disable-line

import { fetchNotifications } from '~services/api.helpers';
import { addToast } from '~features/toast/ducks';
import { receiveNotifications } from '~features/user/ducks';

export const markAsSeenApi = id =>
  api.put(`users/me/notifications/${id}`, { id });
export const deleteNotificationApi = id =>
  api.del(`users/me/notifications/${id}`, { id });

export const markAsSeen = id => async dispatch => {
  try {
    await markAsSeenApi(id);
    const notifications = await fetchNotifications();
    dispatch(receiveNotifications(notifications));
  } catch (e) {
    console.error('Error in markAsSeen', e);
    // dispatch(
    //   addToast({
    //     message: 'Tilojen hakeminen epäonnistui',
    //     type: 'ERROR',
    //   })
    // );
  }
};

export const deleteNotification = id => async (dispatch, getState) => {
  const { notifications: oldNotifications } = getState().user;
  try {
    // Predict success
    dispatch(receiveNotifications(oldNotifications.filter(n => n.id !== id)));

    await deleteNotificationApi(id);
    const notifications = await fetchNotifications();
    dispatch(receiveNotifications(notifications));
  } catch (e) {
    console.error('Error in deleteNotification', e);
    // Undo prediction
    dispatch(receiveNotifications(oldNotifications));
    dispatch(
      addToast({
        message: 'Ilmoituksen poistaminen epäonnistui',
        type: 'ERROR',
      })
    );
  }
};
